var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconMessage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 1C3.23858 1 1 3.23858 1 6C1 6.66416 1.12976 7.29925 1.36578 7.88039C1.3871 7.93289 1.39936 7.96319 1.40776 7.98557L1.41032 7.99247L1.41 7.99485C1.4075 8.01331 1.40336 8.03846 1.39536 8.08648L1.09647 9.87978C1.08306 9.96009 1.06805 10.0499 1.06216 10.128C1.05574 10.2131 1.0535 10.3484 1.11486 10.4915C1.19072 10.6684 1.33165 10.8093 1.5085 10.8851C1.65156 10.9465 1.78693 10.9443 1.87202 10.9378C1.95006 10.9319 2.03993 10.9169 2.12024 10.9035L3.91352 10.6046C3.96154 10.5966 3.98669 10.5925 4.00515 10.59L4.00752 10.5897L4.01443 10.5922C4.03681 10.6006 4.06711 10.6129 4.11961 10.6342C4.70075 10.8702 5.33584 11 6 11C8.76142 11 11 8.76142 11 6C11 3.23858 8.76142 1 6 1ZM3 6C3 5.58579 3.33579 5.25 3.75 5.25C4.16421 5.25 4.5 5.58579 4.5 6C4.5 6.41421 4.16421 6.75 3.75 6.75C3.33579 6.75 3 6.41421 3 6ZM5.25 6C5.25 5.58579 5.58579 5.25 6 5.25C6.41421 5.25 6.75 5.58579 6.75 6C6.75 6.41421 6.41421 6.75 6 6.75C5.58579 6.75 5.25 6.41421 5.25 6ZM8.25 5.25C7.83579 5.25 7.5 5.58579 7.5 6C7.5 6.41421 7.83579 6.75 8.25 6.75C8.66421 6.75 9 6.41421 9 6C9 5.58579 8.66421 5.25 8.25 5.25Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMessage);
export default __webpack_public_path__ + "static/media/icon-message.7b7d5ba29efd728b49e931f1c491d3a0.svg";
export { ForwardRef as ReactComponent };